// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sqfaqdyykjktphkdzamg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNxZmFxZHl5a2prdHBoa2R6YW1nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxMDQ2NzIsImV4cCI6MjA2NTY4MDY3Mn0.w2XzCIIxJj8HihGk7c7ZMd1XTQknyrPLuyGJhEA76WQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);